<template>
    <div>
        <div class="md-layout">
            <div class="md-layout-item md-size-50 mt-2">
                <div class="md-multiselect">
                    <label>Type :</label>
                    <multiselect
                        v-model="intervention.category"
                        :options="computedInterventionCategories"
                        track-by="id"
                        label="name"
                        :option-height="104"
                        placeholder="Séléctionnez un type"
                        :allow-empty="false"
                        :show-labels="false">
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                </div>
            </div>
            <div class="md-layout-item md-size-50 mt-2">
                <div class="md-multiselect">
                    <label>Objet de l'intervention* :
                        <br> (* obligatoire) </label>
                    <multiselect v-model="intervention.type"
                                 :options="types"
                                 track-by="id"
                                 label="name"
                                 placeholder="Séléctionnez un objet"
                                 :option-height="104"
                                 :show-labels="false">
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                </div>
            </div>
        </div>
        <div class="md-layout">
            <div class="md-layout-item md-size-10 mt-2">
                <div class="md-multiselect">
                    <label> Nombre d'interventions : </label>
                    <multiselect v-model="nbIntervention"
                                 :options="nbInterventions"
                                 :option-height="104"
                                 placeholder=""
                                 :allow-empty="false"
                                 :show-labels="false">
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                </div>
            </div>
        </div>
        <div class="md-layout" v-for="index in nbIntervention" :key="index">
            <div class="md-layout-item md-size-10 my-auto">
                <span> Inter {{ index }} :</span>
            </div>
            <div class="md-layout-item md-size-25">
                <div class="md-multiselect">
                    <multiselect v-model="intervention.dates[index-1].month"
                                 :options="months"
                                 :option-height="104"
                                 placeholder="Mois"
                                 track-by="number"
                                 label="label"
                                 :allow-empty="false"
                                 :show-labels="false">
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                </div>
            </div>
            <div class="md-layout-item md-size-25">
                <div class="md-multiselect">
                    <multiselect v-model="intervention.dates[index-1].year"
                                 :options="years"
                                 :option-height="104"
                                 placeholder="Année"
                                 :allow-empty="false"
                                 :show-labels="false">
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                </div>
            </div>
            <div class="md-layout-item md-size-25">
                <md-field class="md-invalid">
                    <label>Temps de travail *</label>
                    <md-input type="time" :name="'date-'+(index-1)" v-model="intervention.dates[index-1].duration" min="00:00"
                              @input="getDuration(index-1)"/>
                    <validation-error :errors="apiValidationErrors['date-'+(index-1)]" />
                </md-field>
            </div>
            <div class="md-layout-item md-size-100">
                <md-field class="md-invalid">
                    <label>Ajouter le détail de l'intervention</label>
                    <md-textarea v-model="intervention.dates[index-1].comment" md-autogrow required></md-textarea>
                </md-field>
            </div>
        </div>
        <div class="md-layout">
            <div class="md-layout-item md-size-33 mt-2">
                <div class="md-multiselect">
                    <label> Client* : </label>
                    <multiselect v-model="intervention.client"
                                 @input="updateSite()"
                                 :options="clients"
                                 track-by="id"
                                 label="name"
                                 placeholder="Séléctionnez un client"
                                 :option-height="104"
                                 :show-labels="false">
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                </div>
            </div>
            <div class="md-layout-item md-size-33 mt-2" v-if="intervention.client">
                <div class="md-multiselect">
                    <label> Site* : </label>
                    <multiselect v-model="intervention.site"
                                 :options="intervention.client.sites"
                                 @input="updateContract()"
                                 track-by="id"
                                 label="name"
                                 placeholder="Séléctionnez un site"
                                 :option-height="104"
                                 :show-labels="false">
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                </div>
            </div>
            <div class="md-layout-item md-size-33 mt-2" v-if="intervention.site">
                <div class="md-multiselect">
                    <label> Contrat : </label>
                    <multiselect v-model="intervention.contract"
                                 :options="intervention.site.contracts"
                                 track-by="id"
                                 label="number"
                                 placeholder="Séléctionnez un contrat"
                                 :option-height="104"
                                 :show-labels="false">
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from "@/mixins/form-mixin";
import { ValidationError } from "@/components";

export default {
    name: "InterventionForm",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        intervention: {
            type: Object,
            default() {
                return {
                    category: null,
                    type: null,
                    client: null,
                    site: null,
                    contract: null,
                    dates: [{
                        month: {
                            number: this.$moment().format('M'),
                            label: this.$moment().format('MMM')
                        },
                        year: this.$moment().year(),
                        duration: '00:00',
                        comment: null,
                        hours: '0',
                        minutes: '0'
                    }]
                }
            }
        },
        errors: Array,
    },
    data() {
        return {
            interventionCategories: [],
            types: [],
            clients: [],
            years: [],
            nbInterventions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
            nbIntervention: 1,
            months: [{number: 1, label: 'janvier'}, {number: 2, label: 'février'}, {number: 3, label: 'mars'},
                {number: 4, label: 'avril'}, {number: 5, label: 'mai'}, {number: 6, label: 'juin'},
                {number: 7, label: 'juillet'}, {number: 8, label: 'août'}, {number: 9, label: 'septembre'},
                {number: 10, label: 'octobre'}, {number: 11, label: 'novembre'}, {number: 12, label: 'décembre'}],
        }
    },
    computed: {
        computedInterventionCategories() {
            return this.interventionCategories.filter(o => o.id !== 1)
        }
    },
    methods: {
        async getInterventionCategories() {
            const {data} = await this.$store.dispatch('interventions/getInterventionCategories')
            this.interventionCategories = data
            this.intervention.category = this.interventionCategories[1]
        },
        async getInterventionTypes() {
            const {data} = await this.$store.dispatch('interventionTypes/getInterventionTypesActives')
            this.types = data
        },
        async getClients() {
            const { data } = await this.$store.dispatch('clients/fetchAllClientsWithSitesAndContracts')
            this.clients = data
        },
        formatYearFilter() {
            for (let i = 0; i <= 15; i++) {
                this.years.push((this.$moment().year() + i))
            }
        },
        getDuration(index) {
            const times = this.intervention.dates[index].duration.split(':')
            if (times.length === 2) {
                this.intervention.dates[index].hours = times[0]
                this.intervention.dates[index].minutes = times[1]
            }
        },
        updateSite() {
            this.intervention.site = null
            this.intervention.contract = null
        },
        updateContract() {
            this.intervention.contract = null
        }
    },
    watch: {
        nbIntervention(newValue) {
            this.intervention.dates = []
            for (let i = 0; i < newValue; i++) {
                this.intervention.dates.push({
                    month: {
                        number: this.$moment().format('M'),
                        label: this.$moment().format('MMMM')
                    },
                    year: this.$moment().year(),
                    comment: null,
                    duration: '00:00',
                    hours: 0,
                    minutes: 0
                })
            }
        },
        errors(newValue) {
            this.setApiValidation(newValue)
        }
    },
    async mounted() {
        this.formatYearFilter()
        await this.getInterventionCategories()
        await this.getInterventionTypes()
        await this.getClients()
        if (this.$route.query.clientId) {
            this.intervention.client = this.clients.find((client) => client.id === parseInt(this.$route.query.clientId)) ?? null;
        }
        if (this.$route.query.siteId) {
            this.intervention.site = this.intervention.client.sites.find((site) => site.id === parseInt(this.$route.query.siteId)) ?? null;
        }
    }
}
</script>

<style scoped lang="scss">
</style>
